<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <rect x="0.777588" y="0.5" width="24" height="24" rx="12" :fill="bgColor" />
    <path
      d="M10.7009 8.53751C10.3229 8.53757 10.0165 8.8441 10.0165 9.22194C10.0165 9.6001 10.3229 9.9065 10.7011 9.90644L14.4207 9.90637L9.0355 15.2926C8.76827 15.5599 8.76827 15.9932 9.03569 16.2606C9.30305 16.5279 9.73626 16.5278 10.0036 16.2605L15.3889 10.8741L15.3888 14.5945C15.3888 14.9726 15.6953 15.2791 16.0733 15.279C16.2623 15.279 16.4335 15.2024 16.5574 15.0785C16.6812 14.9547 16.7577 14.7836 16.7579 14.5946L16.7579 9.22181C16.758 9.04028 16.6859 8.86624 16.5575 8.73782C16.429 8.60946 16.255 8.53744 16.0733 8.53731L10.7009 8.53751Z"
      fill="#FFFFFF" />
  </svg>
</template>

<script>
export default {
  name: "ArrowIcon",
  props: {
    bgColor: {
      type: String,
      default: "#736151"
    }
  }
}
</script>

<style scoped>
@keyframes rotation {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
